import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage
});

export default new Vuex.Store({
    state: {
        userInfo: {},
        cityList: [],
        serviceInfo: '',
        shuttle: {
            payInfo: {}
        },
        serviceAgreement: '',
        yinsiAgreement: '',
        chartData: {},
        paramsData:{}
    },
    mutations: {
        saveUserInfo(state, data) {
            state.userInfo = data;
        },
        removeUserInfo(state, data) {
            window.sessionStorage.clear();
            state.userInfo = {};
        },
        saveCityList(state, data) {
            state.cityList = data;
        },
        saveShuttlePayInfo(state, data) {
            state.shuttle.payInfo = data;
        },
        saveServiceInfo(state, data) {
            state.serviceInfo = data;
        },
        saveServiceAgreement(state, data) {
            state.serviceAgreement = data;
        },
        saveYinsiAgreement(state, data) {
            state.yinsiAgreement = data;
        },
        initChartData(state, data){
            if (!state.chartData[data.id]) {
                state.chartData[data.id] = {};
                state.chartData[data.id].id = data.id;
                state.chartData[data.id].msg = []
                state.chartData[data.id].num = 0;
                state.chartData[data.id].info = data.info;
            }
            state.chartData = {...state.chartData}
        },
        initUserChartData(state, data){
            if (!state.chartData[data.id]) {
                state.chartData[data.id] = {};
                state.chartData[data.id].id = data.id;
                state.chartData[data.id].msg = []
                state.chartData[data.id].num = 0;
                state.chartData[data.id].info = data.info;
            }
            state.chartData[data.id].msg = data.msg;
        },
        setChartDate(state, data){
            state.chartData = data;
        },
        upDateChartData(state, data) {
            if (!data.id) {
                return
            }
            if (!state.chartData[data.id]) {
                state.chartData[data.id] = {}
                state.chartData[data.id].msg = []
                state.chartData[data.id].num = 0;
            }
            if(!state.chartData[data.id].info && data.info){
                state.chartData[data.id].info = data.info;
            }
            state.chartData[data.id].id = data.id;
            state.chartData[data.id].msg.push(data.msg)
        },
        unReadChart(state, data){
            state.chartData[data].num++;
        },
        unReadDel(state, data){
            if(state.chartData[data]){
                state.chartData[data].num = 0;
            }
        },
        updateParamsData(state, data){
            state.paramsData = data
        }
    },
    actions: {},
    modules: {},
    plugins: [vuexLocal.plugin]
})
